import { Withdrawal } from 'widgets/withdrawal';

const WithdrawalPage = () => {
  return <Withdrawal />;
};

export default WithdrawalPage;
